"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ImageLink(id) {
    return "".concat(process.env.REACT_APP_DIRECTUS_BACKEND_ASSETS, "/").concat(id);
}
exports.default = ImageLink;
